export const APP_VIEW = {
  LOADING: 'LOADING',
  RESET_PASSWORD: 'RESET_PASSWORD',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  LOG_IN: 'LOG_IN',
  LOGGED_IN: 'LOGGED_IN',
} as const;
export type APP_VIEW = typeof APP_VIEW;
export type AN_APP_VIEW = APP_VIEW[keyof APP_VIEW];
